import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import ButtonBase from "../Buttons/ButtonBase";

interface MenuProps {
  label?: string;
  icon?: JSX.Element;
  text?: string;
  className?: string;
  containerClass?: string;
  options: {
    name: string;
    icon?: JSX.Element;
    onClick: () => void;
    disabled?: boolean;
    className?: string;
  }[];
  disabled?: boolean;
}

function MenuSelect({
  label,
  icon,
  text,
  className,
  options,
  containerClass,
}: MenuProps) {
  return (
    <Menu as="div" className="relative">
      <MenuButton className="">
        <ButtonBase
          buttonType="tertiary"
          text={text}
          icon={icon}
          className={className}
        />
      </MenuButton>

      <MenuItems
        transition
        className={`flex absolute right-0 flex-col border border-extraLightGray mt-2 w-max 
         bg-white overflow-hidden shadow-lg outline-none rounded-md ${containerClass}`}
      >
        <section className="border-b border-extraLightGray flex items-center px-2">
          <p className="text-sm font-semibold text-subHeading">{label}</p>
        </section>
        {options?.map((option) => (
          <MenuItem key={option?.name}>
            <button
              disabled={option?.disabled}
              type="button"
              className={`px-2 h-8 flex items-center gap-2 text-sm font-medium bg-white 
              transition-colors opacity-90 hover:bg-extraLightGray ${option?.className} `}
              onClick={option?.onClick}
            >
              {option?.icon && <span className="w-4">{option?.icon}</span>}
              <span>{option?.name}</span>
            </button>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
}

export default MenuSelect;
